/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resetpassword21Inputs */

const en_resetpassword21 = /** @type {(inputs: Resetpassword21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset password`)
};

const de_resetpassword21 = /** @type {(inputs: Resetpassword21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset password" |
*
* @param {Resetpassword21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const resetpassword21 = /** @type {((inputs?: Resetpassword21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resetpassword21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resetpassword21(inputs)
	return de_resetpassword21(inputs)
});
export { resetpassword21 as "resetPassword2" }